import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import DesignroomProductList from './DesignroomProductList';

class DesignroomProducts extends Component {
  render() {
    const { defaultLanguage, shopId } = this.props;
    return (
      <Grid>
        <DesignroomProductList
          defaultLanguage={defaultLanguage}
          shopId={shopId}
        />
      </Grid>
    );
  }
}
export default DesignroomProducts;
